
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-61071b98!sass-loader?indentedSyntax&sourceMap!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./simpleColums2.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./simpleColums2.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-61071b98!../../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./simpleColums2.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/structure/simpleColums2.vue
// module id = 2034
// module chunks = 1